import Interceptor from "@/plugins/interceptor.js";

const urlAPI = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GAME_ACTION}`;

const GameMessage = {
  state: {},
  actions: {
    sendMessage: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/sendMessage`, params);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    goalSend: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/goalSend`, params)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    setScore: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/setScore`, params)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    requestThrowPapers: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/requestThrowPapers`, params)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    getFanPicturePendingReview: async ({}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getFanPicturePendingReview?gameId=${params.gameId}&teamId=${params.teamId}`)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    getFanPictureApproved: async ({}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getFanPictureApproved?gameId=${params.gameId}&teamId=${params.teamId}&pageNumber=${params.pageNumber}&rowsPerPage=${params.rowsPerPage}`)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    approveFanPicture: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/approveFanPicture?id=${params.id}`)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    rejectFanPicture: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/rejectFanPicture?id=${params.id}`)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    // fanPictureMarkAsDownloaded: async ({}, params) => {
    //   try {
    //     const response = await Interceptor.post(`${urlAPI}/fanPictureMarkAsDownloaded?id=${params.id}`)
    //   } catch (error) {
    //     console.error(error)
    //   }
    // },
    downloadFanPictures: async ({}, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/downloadFanPictures`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    }
  },
  mutations: {}
};

export default GameMessage;